import {
    KYC_SETTING_LIST_INITIATED,
    KYC_SETTING_INITIATED,
    KYC_SETTING_LOADED,
    KYC_SETTING_FAILED,
    KYC_SETTING_LIST_LOADED
  } from "../actions/KYCSettingAction";
  
  const initialState = {
    listdata: [],
    data: [],
    pagination: {
      total: 0,
      page: 1,
      limit: 10,
      totalPages: 1,
      nextPage: null,
    },
    loading: false,
    error: null
  };
  
  const KYCSettingReducer = (state = initialState, action) => {
    switch (action.type) {
      case KYC_SETTING_LIST_INITIATED:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case KYC_SETTING_LIST_LOADED:
        return {
          ...state,
          loading: false,
          listdata: action.payload.data,
          pagination: action.payload.pagination,
        };
      case KYC_SETTING_INITIATED:
        return { ...state, loading: true, error: null };
      case KYC_SETTING_LOADED:
        return { ...state, loading: false, data: action.payload };
      case KYC_SETTING_FAILED:
        return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  export default KYCSettingReducer;